import React from 'react';
import { toast } from 'react-toastify';
import clsx from 'clsx';
import Button from '../_custom/Button/Button';
import { GREEN_BG_WHITE_TICK_CIRCLE, crossBtnGrey, whiteArrowTilted } from '../../assets/hostedassets';
import tooltipStyles from '../PersistentConfigToolTip/PersistentConfigToolTip.module.scss';
import actionStyles from '../ConfirmDialog/modalOverDrawer.module.scss';
import styles from './addedToReportsToast.module.scss';

const AddedToReportsToastCard: React.FC<{ onView: () => void; closeToast?: () => void }> = ({ onView, closeToast }) => (
    <div className={clsx(tooltipStyles.tooltipContent, styles.card)}>
        <button type="button" className={tooltipStyles.closeButton} onClick={() => closeToast?.()} aria-label="Close">
            <img src={crossBtnGrey} alt="" />
        </button>
        <div className={styles.body}>
            <img src={GREEN_BG_WHITE_TICK_CIRCLE} alt="" aria-hidden="true" className={styles.icon} />
            <div className={styles.text}>
                {/* Says a NEW copy was saved and the source is untouched, so nobody
                    reads it as the uploaded file having been updated (RECUR-27850). */}
                <h3 className={clsx(tooltipStyles.tooltipHeading, styles.heading)}>Added to Workspace</h3>
                <p className={clsx(tooltipStyles.tooltipMessage, styles.message)}>
                    Saved as a new document in Workspace. The original file is unchanged.
                </p>
            </div>
        </div>
        <div className={styles.actions}>
            <Button text="Dismiss" variant="secondary" className={actionStyles.actionBtn} onClick={() => closeToast?.()} />
            <Button
                text="Open in Workspace"
                variant="primary"
                icon={whiteArrowTilted}
                iconStyles={{ marginRight: '0.375rem', height: '0.875rem' }}
                className={actionStyles.actionBtn}
                onClick={() => {
                    onView();
                    closeToast?.();
                }}
            />
        </div>
    </div>
);

export const showAddedToReportsToast = (onView: () => void, onClose?: () => void) => {
    toast.success(({ closeToast }: { closeToast?: () => void }) => <AddedToReportsToastCard onView={onView} closeToast={closeToast} />, {
        icon: false,
        closeButton: false,
        className: styles.toastReset,
        onClose,
    });
};
